import React from 'react';
import MaterialCircularProgress from '@mui/material/CircularProgress';
import type {CircularProgressProps as MaterialProgressProps} from '@mui/material/CircularProgress';
import {FuelSize, getFuelSize} from '../types/general';

type FuelVariants = 'indeterminate' | 'determinate';

export interface CircularProgressProps extends Omit<MaterialProgressProps,
'variant' | 'color' | 'thickness'
> {
    variant?: FuelVariants;
    size?: FuelSize;
}

const sizes: Record<string, any> = {
    small: {
        size: '1rem',
        thickness: 5
    },
    medium: {
        size: '2rem',
        thickness: 4
    },
    large: {
        size: '3rem',
        thickness: 3
    }
};

export const CircularProgress = React.forwardRef<any, CircularProgressProps>(({
    size: currentSize = 'medium', variant = 'indeterminate', ...props
}, ref) => {
    const size = getFuelSize(currentSize);

    return (
        <MaterialCircularProgress
            color='primary'
            ref={ref}
            size={sizes[size].size}
            thickness={sizes[size].thickness}
            variant={variant}
            {...props}
        />
    );
});

CircularProgress.displayName = 'CircularProgress';
